(() => {
  /**
   * 必须用 /cart/add.js（AJAX 端点，恒返回 JSON）。
   * Ella 把 window.routes.cart_add_url 设成了 '/cart/add' —— 那是表单端点，
   * 视会话/市场状态可能返回 HTML 重定向页，前端 JSON 解析就会炸成
   * "Unexpected token '<', \"<!DOCTYPE \"... is not valid JSON"。
   * 用 Shopify.routes.root 拼接，同时兼容多语言/多市场的路径前缀。
   */
  const cartAddUrl = () => {
    let root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!root.endsWith('/')) root += '/';
    return root + 'cart/add.js';
  };
  if (customElements.get('mziho-dynamic-configurator')) return;

  class MzihoDynamicConfigurator extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.variants = this.parse('[data-mziho-variants]', []);
      this.schema = this.parse('[data-mziho-schema]', null);
      this.currentVariant = this.variants.find((variant) => String(variant.id) === String(this.querySelector('[data-mziho-variant-id]')?.value)) || this.variants[0];
      this.variantInput = this.querySelector('[data-mziho-variant-id]');
      this.quantityInput = this.querySelector('[data-mziho-cart-quantity]');
      this.submitButton = this.querySelector('[data-mziho-submit]');
      this.submitLabel = this.querySelector('[data-mziho-submit-label]');
      this.defaultSubmitLabel = this.submitLabel?.dataset.defaultLabel || this.submitLabel?.textContent || 'Add to cart';
      this.errorRegion = this.querySelector('[data-mziho-error]');
      this.currency = this.dataset.currencyCode || 'USD';
      this.cartDrawer = document.querySelector('cart-drawer');

      this.form.addEventListener('change', (event) => this.onChange(event));
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.querySelector('[data-mziho-mobile-submit]')?.addEventListener('click', () => this.form.requestSubmit());
      this.querySelectorAll('[data-mziho-field]').forEach((field) => field.addEventListener('blur', () => this.validateField(field)));
      this.closest('.mziho-dynamic-product')?.querySelectorAll('[data-mziho-media-src]').forEach((button) => button.addEventListener('click', () => this.changeMedia(button)));
      this.localizeOptionPrices();
      this.updateConditions();
      this.update();
      this.showPostedNotice();
    }

    parse(selector, fallback) {
      try { return JSON.parse(this.querySelector(selector)?.textContent || ''); }
      catch (_error) { return fallback; }
    }

    changeMedia(button) {
      const image = this.closest('.mziho-dynamic-product')?.querySelector('.mziho-dynamic-product__main-media img');
      if (!image || !button.dataset.mzihoMediaSrc) return;
      image.src = button.dataset.mzihoMediaSrc;
      image.removeAttribute('srcset');
      this.closest('.mziho-dynamic-product')?.querySelectorAll('[data-mziho-media-src]').forEach((item) => item.classList.toggle('is-active', item === button));
    }

    onChange(event) {
      this.clearError();
      // 发完询价后再改任何选项 = 要发新的一份：收起成功卡片，询价表单回来（填过的名字邮箱都还在）。
      if (this.quoteSent) this.resetQuoteSent();
      if (event.target.matches('[data-field-type="file"]')) {
        const wrap = event.target.parentElement;
        const file = event.target.files?.[0];
        const label = wrap?.querySelector('[data-file-name]');
        if (label) label.textContent = file?.name || 'No file selected';
        // 2026-10-21：选好文件后按钮变「Change file」+ 绿框、文件名带 ✓（样式见 mziho-dynamic-configurator.css 的 data-file-picked）。
        // 原来只有灰色小字变化，客人看不出已经选上，隔几分钟又点一次 Upload。
        const button = wrap?.querySelector('.mziho-dynamic-upload > span');
        if (button) {
          if (!button.dataset.label) button.dataset.label = button.textContent;
          button.textContent = file ? 'Change file' : button.dataset.label;
        }
        wrap?.toggleAttribute('data-file-picked', Boolean(file));
      }
      this.updateConditions();
      this.update();
    }

    fieldValue(key) {
      const fields = [...this.querySelectorAll(`[data-mziho-field][data-field-key="${CSS.escape(key)}"]`)];
      const checkbox = fields.find((field) => field.type === 'checkbox');
      if (checkbox) return checkbox.checked ? 'true' : 'false';
      const selected = fields.find((field) => !['radio', 'checkbox'].includes(field.type) || field.checked);
      return selected?.value || '';
    }

    updateConditions() {
      this.querySelectorAll('[data-condition-field]').forEach((wrapper) => {
        const expected = String(wrapper.dataset.conditionValue || '').toLowerCase();
        const actual = String(this.fieldValue(wrapper.dataset.conditionField) || '').toLowerCase();
        const visible = actual === expected;
        wrapper.hidden = !visible;
        wrapper.querySelectorAll('input, select, textarea').forEach((control) => {
          if (!visible) {
            if (!control.hasAttribute('data-was-required')) control.dataset.wasRequired = String(control.required);
            control.required = false;
            control.disabled = true;
          } else {
            control.disabled = false;
            if (control.dataset.wasRequired === 'true') control.required = true;
            delete control.dataset.wasRequired;
          }
        });
      });
    }

    selectedControl(selector) {
      return [...this.querySelectorAll(selector)].find((control) => !control.disabled && (control.type !== 'radio' || control.checked));
    }

    resolveVariant(overrideControl = null) {
      const base = [...(this.currentVariant?.options || [])];
      this.querySelectorAll('[data-variant-position]').forEach((control) => {
        if (control.closest('[data-mziho-field-wrap]')?.hidden || (control.type === 'radio' && !control.checked)) return;
        const position = Number(control.dataset.variantPosition || 0);
        if (position > 0) base[position - 1] = control.dataset.optionValue || control.value;
      });
      if (overrideControl) {
        const position = Number(overrideControl.dataset.variantPosition || 0);
        if (position > 0) base[position - 1] = overrideControl.dataset.optionValue || overrideControl.value;
      }
      return this.variants.find((variant) => variant.options.every((option, index) => String(option) === String(base[index]))) || (this.variants.length === 1 ? this.variants[0] : null);
    }

    quantity() {
      const control = [...this.querySelectorAll('[data-field-type="quantity"]')].find((field) => !field.closest('[data-mziho-field-wrap]')?.hidden && (field.type !== 'radio' || field.checked));
      const quantity = Number.parseInt(control?.dataset.quantity || control?.value || '1', 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    addons() { return [...this.querySelectorAll('[data-field-type="addon"]:checked:not(:disabled)')]; }

    /**
     * 单选 / 图选 / 下拉里带 price 的取值，也要计入小计并真的收钱。
     * 只有 addons 类型收钱是不够的 —— 工艺、边缘、饰面、包装这些都是「N 选 1」，
     * 做成多选勾在语义上就错了。
     */
    /**
     * 一个带价取值该收多少钱（返回**元**）。
     *   'per_unit'（默认）  固定单价 × 数量
     *   'once'              一次性
     *   'percent'           **变体单价**的百分比 × 数量
     *
     * ⚠ percent 的基数是「变体单价」，不含其它选项的加价 ——
     *   对齐 GS-JJ 的口径 "+26% of unit price"；否则多个百分比叠加会滚雪球。
     * ⚠ unitCents 是**分**，price 存的是百分数本身（26 就是 26%）。
     */
    chargeAmount(price, charge, quantity, unitCents) {
      if (charge === 'once') return price * this.fxRate();
      if (charge === 'percent') return (Number(unitCents) / 100) * (price / 100) * quantity;
      return price * this.fxRate() * quantity;
    }

    /**
     * 2026-10-21：美元 → 客人当地币的汇率。
     * 配置里的 price / moldFee / add-on 价都是**美元**；变体价、加价商品单价、购物车都是当地币。
     * 原来直接把美元数当当地币：GTQ 下应加 $2.50 只收了 Q2.48（≈$0.32），GBP/EUR 下反过来多收。
     * Shopify.currency.rate 是 Shopify 给商品价换汇用的同一个汇率（市场没开价格取整）。
     * USD 恒为 1，行为不变。percent 的基数是变体单价，本来就是当地币，不乘。
     */
    fxRate() {
      if (!this.currency || this.currency === 'USD') return 1;
      const active = window.Shopify?.currency;
      const rate = Number(active?.rate);
      if (active?.active === this.currency && rate > 0) return rate;
      // 兜底：拿不到汇率就用加价商品（$0.01）的当地币单价反推 —— 粗，但绝不能按 1 收
      const unit = Number(this.dataset.surchargeUnit || 0);
      return unit > 0 ? unit : 1;
    }

    /** 加价实收（分）：件数取整后 × 加价商品单价，和 addSurcharge 收的一致。USD 单价 1 分，即四舍五入到分。 */
    chargedSurchargeCents(amount) {
      const unitCents = Number(this.dataset.surchargeUnit || 1) || 1;
      return amount > 0 ? Math.round((amount * 100) / unitCents) * unitCents : 0;
    }

    /**
     * 2026-10-21：选项卡片上的「+$0.10 ea」是 Liquid money 过滤器直接格式化的美元数，非 USD 会显示成「Q0.10 ea」。
     * 按 data-* 里的美元价换成当地币重写。只改已有文本节点的 nodeValue（不动 childList）；USD 不动。
     */
    localizeOptionPrices() {
      const rate = this.fxRate();
      if (rate === 1) return;
      const fmt = (usd) => this.formatMoney(Math.round(Number(usd) * 100 * rate));
      const put = (el, text) => {
        const node = el && [...el.childNodes].find((n) => n.nodeType === 3 && /\d/.test(n.nodeValue));
        if (node && node.nodeValue !== text) node.nodeValue = text;
      };
      this.querySelectorAll('input[data-option-price], input[data-option-mold-fee]').forEach((input) => {
        const label = input.closest('label');
        if (!label) return;
        const p = Number(input.dataset.optionPrice || 0);
        const charge = input.dataset.optionCharge;
        if (p && charge !== 'percent') put(label.querySelector('.mziho-dynamic-option__price, .mziho-addon__price:not(.mziho-addon__moldfee)'), `+${fmt(p)}${charge === 'once' ? '' : ' ea'}`);
        const mold = Number(input.dataset.optionMoldFee || 0);
        if (mold) put(label.querySelector('.mziho-addon__moldfee'), `+ Mold fee ${fmt(mold)}`);
      });
      this.querySelectorAll('input[type="checkbox"][data-addon-price]').forEach((input) => {
        const p = Number(input.dataset.addonPrice || 0);
        if (p) put(input.closest('label')?.querySelector('.mziho-addon__price:not(.mziho-addon__moldfee)'), `${fmt(p)}${input.dataset.addonCharge === 'per_unit' ? ' ea' : ''}`);
      });
      this.querySelectorAll('option[data-option-price]').forEach((opt) => {
        const p = Number(opt.dataset.optionPrice || 0);
        const charge = opt.dataset.optionCharge;
        const node = opt.firstChild;
        if (!p || charge === 'percent' || node?.nodeType !== 3) return;
        const text = node.nodeValue.replace(/\(\+[^()]*\)\s*$/, `(+${fmt(p)}${charge === 'once' ? '' : ' ea'})`);
        if (text !== node.nodeValue) node.nodeValue = text;
      });
    }
    optionSurcharge(quantity) {
      let total = 0;
      const unitCents = Number(this.resolveVariant()?.price || 0);
      // ⚠ :not(:disabled)：询价专用字段（[data-mziho-quote-only] fieldset）不选 Custom 时是禁用的，
      //   里面默认或残留的选中项不能算进加购小计，更不能真的收钱。（2026-09-12）
      this.querySelectorAll('input[type="radio"][data-option-price]:checked:not(:disabled), input[type="radio"][data-option-mold-fee]:checked:not(:disabled)').forEach((el) => {
        const p = Number(el.dataset.optionPrice || 0);
        if (p) total += this.chargeAmount(p, el.dataset.optionCharge, quantity, unitCents);
        // 模具费是一次性的，不乘数量。取值可以只有模具费、没有每件加价。
        total += Number(el.dataset.optionMoldFee || 0) * this.fxRate();
      });
      this.querySelectorAll('select[data-mziho-field]:not(:disabled)').forEach((sel) => {
        const opt = sel.options[sel.selectedIndex];
        const p = Number(opt?.dataset?.optionPrice || 0);
        if (p) total += this.chargeAmount(p, opt.dataset.optionCharge, quantity, unitCents);
      });
      /**
       * 付费 add-on 也走这条 $0.01 计分的路。
       * 原来 add-on 只有配了 `variantId`（一个专属 $1.00 商品）才收得到钱，
       * 没配的会「小计显示了加价、实际一分不收」。
       * 那 4 个 Add-on 商品 2026-08-29 已清理掉，所以这里必须兜住。
       * 配了 variantId 的仍走 addPaidAddons，这里跳过，避免重复收。
       */
      this.querySelectorAll('input[type="checkbox"][data-field-type="addon"]:checked:not(:disabled)').forEach((el) => {
        if (el.dataset.addonVariantId) return;
        const p = Number(el.dataset.addonPrice || 0);
        if (p) total += p * this.fxRate() * (el.dataset.addonCharge === 'per_unit' ? quantity : 1);
      });
      return total;
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.currency }).format(Number(cents || 0) / 100);
      } catch (_error) { return `$${(Number(cents || 0) / 100).toFixed(2)}`; }
    }

    /**
     * 每件加价（分）—— 只算**会影响单件价**的两种：
     *   percent   变体单价的百分比（工艺差价走这个）
     *   per_unit  固定单价
     * `once` 不算：模具费是一次性的，摊不进「每件多少钱」。
     * ⚠ 只看选中且没被禁用的 —— showIf 隐藏的字段控件是 disabled 的，不该计入。
     */
    unitSurchargeCents(unitCents) {
      let add = 0;
      this.querySelectorAll('input[type="radio"][data-option-price]:checked:not(:disabled)').forEach((el) => {
        const p = Number(el.dataset.optionPrice || 0);
        if (!p) return;
        const charge = el.dataset.optionCharge;
        if (charge === 'percent') add += Number(unitCents) * (p / 100);
        else if (charge !== 'once') add += p * 100 * this.fxRate();
      });
      return add;
    }

    updateQuantityPrices() {
      this.querySelectorAll('[data-field-type="quantity"]').forEach((control) => {
        const variant = this.resolveVariant(control);
        const price = control.closest('label')?.querySelector('[data-unit-price-for-quantity]');
        /* ⚠ 必须把每件加价算进显示价，否则「档位显示 $8.77 / 实收 $9.65」——
           显示≠实收，和 2026-09-06 那个负加价 bug 同一类。 */
        if (price) {
          price.textContent = variant?.available
            ? `${this.formatMoney(Number(variant.price) + this.unitSurchargeCents(variant.price))} ea`
            : 'Unavailable';
        }
        control.disabled = Boolean(variant && !variant.available);
      });
    }

    /** 是否选了「自定义数量」。任意数量对不上变体，所以这时不报价，走询价。 */
    isCustomQuantity() {
      return Boolean(this.querySelector('[data-custom-quantity]:checked'));
    }

    /** 展开/收起自定义数量输入框，并同步 required。 */
    syncCustomQuantity() {
      const wrap = this.querySelector('[data-mziho-custom-qty-wrap]');
      const input = this.querySelector('[data-mziho-custom-qty]');
      if (!wrap || !input) return;
      const on = this.isCustomQuantity();
      wrap.hidden = !on;
      // disabled 的输入不会被提交。不这么做的话，没选 Custom 时订单里
      // 也会多出一个空的 "Quantity (custom)" 属性，客户和后台都会看到一行空值。
      input.disabled = !on;
      if (on) input.setAttribute('required', 'required');
      else { input.removeAttribute('required'); input.value = ''; }
    }

    /**
     * 询价专用字段（购物车才有的背扣/包装/升级等）只在选了 Custom 数量时展开并启用。
     * 整个字段包在 <fieldset disabled> 里：禁用的 fieldset 让里面所有控件不提交、不校验、
     * 也不会被 :not(:disabled) 的加价统计扫到 —— 正常加购完全不受影响。（2026-09-12）
     */
    syncQuoteOnly() {
      const on = this.isCustomQuantity();
      this.querySelectorAll('[data-mziho-quote-only]').forEach((box) => { box.hidden = !on; box.disabled = !on; });
    }

    update() {
      this.syncCustomQuantity();
      this.syncQuoteOnly();
      this.updateQuantityPrices();

      if (this.isCustomQuantity()) {
        // 不猜价格：小计显示待报价，按钮切成询价文案，但保持可点。
        const msg = 'Quote required';
        this.querySelectorAll('[data-mziho-subtotal], [data-mziho-mobile-subtotal]').forEach((n) => { n.textContent = msg; });
        this.querySelectorAll('[data-mziho-unit-price]').forEach((n) => { n.textContent = msg; });
        // 隐藏字段也要同步成 "Quote required"。不同步的话它们会留着切换到
        // 自定义之前那个档位的价格，跟着询价请求一起提交，邮件里出现一个
        // 与本次询价无关的价格。页面显示与提交数据必须一致。
        const unitProp = this.querySelector('[data-mziho-property-unit]');
        const subtotalProp = this.querySelector('[data-mziho-property-subtotal]');
        if (unitProp) unitProp.value = msg;
        if (subtotalProp) subtotalProp.value = msg;
        const requestType = this.querySelector('[name="properties[_Request type]"]');
        if (requestType) requestType.value = 'Instant quote';
        const label = this.submitButton?.querySelector('[data-mziho-submit-label]') || this.submitButton;
        // 询价已发出：按钮锁住、文案改成已发送，防止连点重复发（2026-10-22）
        if (label) label.textContent = this.quoteSent ? 'Quote request sent' : this.quoteLabel();
        if (this.submitButton) this.submitButton.disabled = Boolean(this.quoteSent);
        this.toggleQuoteBlock(true);
        const qty = Number(this.querySelector('[data-mziho-custom-qty]')?.value || 0);
        if (this.quantityInput) this.quantityInput.value = qty > 0 ? qty : 1;
        return;
      }
      const variant = this.resolveVariant();
      const quantity = this.quantity();
      // ⚠ 小计全程以「分」为单位（variant.price 是分，formatMoney 会 /100）。
      // 配置里的 price 是「元」，必须 ×100 再相加，否则会少收 100 倍。
      // 只算有专属商品的 add-on；没有专属商品的已经在 optionSurcharge 里算过了，
      // 两边都算会让小计翻倍。
      const addonTotal = this.addons()
        .filter((addon) => addon.dataset.addonVariantId)
        .reduce((total, addon) => {
          const price = Number(addon.dataset.addonPrice || 0) * 100 * this.fxRate();
          return total + price * (addon.dataset.addonCharge === 'per_unit' ? quantity : 1);
        }, 0);
      const available = Boolean(variant?.available);
      const surcharge = this.optionSurcharge(quantity);
      // surcharge 以「元」返回（当地币；addSurcharge 收款时也按元换算），这里转成分。
      // 2026-10-21：按实收取整（加价商品单价的整数倍，GTQ 一件 Q0.08），小计 = 购物车实收；USD 结果不变。
      const subtotal = available ? Number(variant.price) * quantity + addonTotal + this.chargedSurchargeCents(surcharge) : 0;
      const subtotalText = available ? this.formatMoney(subtotal) : 'Unavailable';
      const unitText = available ? this.formatMoney(variant.price) : 'Unavailable';
      this.querySelectorAll('[data-mziho-subtotal], [data-mziho-mobile-subtotal]').forEach((node) => { node.textContent = subtotalText; });
      if (this.variantInput) this.variantInput.value = available ? variant.id : '';
      if (this.quantityInput) this.quantityInput.value = quantity;
      const unitProperty = this.querySelector('[data-mziho-property-unit]');
      const subtotalProperty = this.querySelector('[data-mziho-property-subtotal]');
      if (unitProperty) unitProperty.value = unitText;
      if (subtotalProperty) subtotalProperty.value = subtotalText;
      if (this.submitButton) this.submitButton.disabled = !available;
      // 从「Custom」切回某个档位时，按钮文案要从「Request a quote」变回来，
      // 否则客户会拿着一个写着「询价」的按钮做加购。
      const cartLabel = this.submitButton?.querySelector('[data-mziho-submit-label]') || this.submitButton;
      if (cartLabel) cartLabel.textContent = this.defaultSubmitLabel;
      this.toggleQuoteBlock(false);
    }

    quoteLabel() { return this.dataset.quoteLabel || 'Request a quote'; }

    /** 询价块只在自定义数量时出现。 */
    toggleQuoteBlock(on) {
      const block = this.querySelector('[data-mziho-quote]');
      // 发送成功后询价表单收起，位置让给成功卡片（[data-mziho-quote-done]）
      if (block) block.hidden = !on || Boolean(this.quoteSent);
      // 询价块一露面就去预热验证码：加载 hCaptcha 要几秒，等客户点了再开始就来不及。
      if (on) this.primeQuoteCaptcha();
      if (!on) {
        this.quoteSent = false;
        const done = this.querySelector('[data-mziho-quote-done]');
        if (done) { done.hidden = true; done.textContent = ''; }
      }
    }

    validateField(field) {
      field.removeAttribute('aria-invalid');
      if (!field.checkValidity()) field.setAttribute('aria-invalid', 'true');
      return field.checkValidity();
    }

    validate() {
      const invalid = [...this.querySelectorAll('[data-mziho-field]:not(:disabled)')].find((field) => !this.validateField(field));
      if (invalid) {
        this.showError('Please complete the required option before continuing.');
        invalid.focus();
        return false;
      }
      if (!this.variantInput?.value) {
        this.showError('This option combination is unavailable. Choose another combination.');
        return false;
      }
      return true;
    }

    configurationId() {
      const input = this.querySelector('[data-mziho-configuration-id]');
      if (input && !input.value) input.value = `mziho-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      return input?.value || '';
    }

    appendAddonProperties(formData) {
      const grouped = new Map();
      this.addons().forEach((addon) => {
        const key = addon.dataset.fieldKey || 'Add-ons';
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key).push(addon.value);
      });
      grouped.forEach((values, key) => formData.append(`properties[${key}]`, values.join(', ')));
    }

    sections() {
      if (!this.cartDrawer || typeof this.cartDrawer.getSectionsToRender !== 'function') return [];
      return this.cartDrawer.getSectionsToRender().map((section) => section.id);
    }

    async addMainItem(groupId) {
      const formData = new FormData(this.form);
      this.appendAddonProperties(formData);
      const sections = this.sections();
      if (sections.length) {
        formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
      }
      const response = await fetch(cartAddUrl(), { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'The product could not be added.');
      return data;
    }

    /**
     * 把单选/下拉的加价真正收进购物车。
     * 做法：往购物车加 N 个 $0.01 的商品 = 收 N 分钱（这类配置器的通用做法，
     * 店里原本就有一个 handle=product-options 的商品在干这事）。
     * 该商品必须已发布且关闭库存跟踪 —— 收 $50 就是加 5000 个。
     */
    async addSurcharge(groupId) {
      const variantId = Number(this.dataset.surchargeVariantId || 0);
      if (!variantId) return null;
      const unitCents = Number(this.dataset.surchargeUnit || 1);   // 单价，分
      const amount = this.optionSurcharge(this.quantity());
      if (!(amount > 0) || !(unitCents > 0)) return null;
      const units = Math.round((amount * 100) / unitCents);
      if (units < 1) return null;

      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: units,
            // 2026-10-21：_Currency 记下加购时的币种，购物车发现换了币种会按新币种重建件数（见 mziho-cart-configurator.js）
            properties: { '_Configurator parent': groupId, 'Upgrade for': 'Selected options', _Currency: this.currency },
          }],
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'The option surcharge could not be added.');
      return data;
    }

    /** 撤掉这次加购已经加进去的加价行 / 附加品（主商品没加成功时用，免得只收了加价没有商品）。 */
    async removeChildLines(groupId) {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const updates = {};
      (cart.items || []).forEach((line) => { if (line.properties?.['_Configurator parent'] === groupId) updates[line.key] = 0; });
      if (!Object.keys(updates).length) return;
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
    }

    async addPaidAddons(groupId) {
      const addons = this.addons().filter((addon) => addon.dataset.addonVariantId);
      if (!addons.length) return null;
      const quantity = this.quantity();
      const items = addons.map((addon) => ({
        id: Number(addon.dataset.addonVariantId),
        quantity: addon.dataset.addonCharge === 'per_unit' ? quantity : 1,
        properties: { '_Configurator parent': groupId, 'Upgrade for': addon.value },
      }));
      const body = { items };
      const sections = this.sections();
      if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
      const response = await fetch(cartAddUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'A paid add-on could not be added.');
      return data;
    }

    renderCart(data) {
      if (this.cartDrawer && typeof this.cartDrawer.renderContents === 'function' && data) {
        this.cartDrawer.setActiveElement?.(document.activeElement);
        this.cartDrawer.renderContents(data);
      } else window.location.assign(window.routes?.cart_url || '/cart');
    }

    async onSubmit(event) {
      event.preventDefault();
      this.clearError();
      // 自定义数量对不上任何变体，没有价格可加购 —— 走询价，不走购物车。
      if (this.isCustomQuantity()) return this.submitQuote();
      if (!this.validate()) return;
      const groupId = this.configurationId();
      this.setLoading(true);
      // 2026-10-21：主商品最后加，订单和手机推送里它才排第一行（Shopify 后加的行排在前面）。
      let mainAdded = false;
      try {
        await this.addSurcharge(groupId);
        await this.addPaidAddons(groupId);
        const main = await this.addMainItem(groupId);
        mainAdded = true;
        // 2026-10-22：清空编号，同一页再加一款会拿新编号。原来不清空，第二款和第一款共用一个，
        //   购物车里保存其中一行会按编号把另一行的加价一起删掉（少收）。
        const idInput = this.querySelector('[data-mziho-configuration-id]');
        if (idInput) idInput.value = '';
        this.renderCart(main);
      } catch (error) {
        if (!mainAdded) await this.removeChildLines(groupId).catch(() => {});
        this.showError(error.message || 'Please try again.');
      } finally { this.setLoading(false); }
    }

    /**
     * 把当前所有可见字段的选择整理成一段人能读的文本。
     * 隐藏字段（showIf 没满足的）不收，否则报价单里会出现客户没选过的东西。
     */
    /**
     * 2026-09-12：
     *   links = { 字段 key: 上传后的文件 URL }，有 URL 写 URL，没有才写文件名。
     *   带价取值后面附上价格，店主报价时不用再去查表。
     *   add-on 字段在循环里跳过 —— fieldValue() 对复选框只会回 'true'，会写出一行
     *   "Upgrades: true"；add-on 统一在下面的 "Add-ons:" 一行里列出（带价格）。
     */
    collectSelections(links = {}) {
      const money = (n) => `$${Number(n).toFixed(2)}`;
      const lines = [];
      this.querySelectorAll('[data-mziho-field-wrap][data-field-key]').forEach((wrap) => {
        if (wrap.hidden || wrap.offsetParent === null) return;
        const key = wrap.dataset.fieldKey;
        if (!key) return;
        if (wrap.querySelector('[data-field-type="addon"]')) return;
        const file = wrap.querySelector('[data-field-type="file"]');
        let value = file ? (links[key] || file.files?.[0]?.name || '') : this.fieldValue(key);
        if (!value || value === 'false') return;
        // 数量在上面已经单独写了真实数字，这里再写一行 "Quantity: custom" 只会让人困惑
        if (value === 'custom') return;
        const picked = file ? null : wrap.querySelector('input[type="radio"]:checked:not(:disabled)');
        if (picked) {
          const extra = [];
          const p = Number(picked.dataset.optionPrice || 0);
          if (p) {
            if (picked.dataset.optionCharge === 'percent') extra.push(`+${p}% of unit price`);
            else if (picked.dataset.optionCharge === 'once') extra.push(`+${money(p)} once`);
            else extra.push(`+${money(p)} ea`);
          }
          if (Number(picked.dataset.optionMoldFee || 0)) extra.push(`mold fee ${money(picked.dataset.optionMoldFee)}`);
          if (extra.length) value += ` (${extra.join(', ')})`;
        }
        lines.push(`${key}: ${value}`);
      });
      const addons = this.addons().map((a) => {
        const label = a.dataset.addonLabel || a.value;
        const p = Number(a.dataset.addonPrice || 0);
        return p ? `${label} (+${money(p)}${a.dataset.addonCharge === 'per_unit' ? ' ea' : ' once'})` : label;
      }).filter(Boolean);
      if (addons.length) lines.push(`Add-ons: ${addons.join(', ')}`);
      return lines;
    }

    /**
     * 询价：走 Shopify 自带的联系表单端点，邮件直接进店铺客服邮箱。
     * 不需要装应用、不需要后端。附件发不了，所以正文里提示客户另外邮件发原图。
     */
    /** 询价表单的引用。整页只有一个。 */
    /**
     * 询价时把可见的图稿文件传到 Shopify，换成可点开的链接（2026-09-12）。
     * 返回 { 字段 key: url 或「文件名 (upload failed…)」 }。任何失败都不抛出 —— 询价照发。
     * 载体变体 = data-surcharge-variant-id（product-options），上传逻辑见 assets/mziho-upload-link.js。
     */
    async uploadArtwork() {
      const links = {};
      const carrier = this.dataset.surchargeVariantId;
      const inputs = [...this.querySelectorAll('[data-field-type="file"]')].filter((input) => {
        const wrap = input.closest('[data-mziho-field-wrap]');
        return input.files?.[0] && !input.matches(':disabled') && wrap && !wrap.hidden && wrap.offsetParent !== null;
      });
      for (const input of inputs) {
        const key = input.dataset.fieldKey || 'Artwork';
        const file = input.files[0];
        try {
          if (!window.MzihoUpload) throw new Error('uploader not loaded');
          links[key] = await window.MzihoUpload.toLink(file, carrier);
        } catch (error) {
          console.warn('[mziho] artwork upload failed', error);
          links[key] = `${file.name} (upload failed, please ask the customer to email this file)`;
        }
      }
      return links;
    }

    quoteForm() { return document.querySelector('.mziho-product-quote__form'); }

    /**
     * 人为触发一次 focusin，让 Shopify 去加载并绑定验证码。
     * Shopify 只在 focusin / change 来自 contact 表单时才绑定，而我们的表单
     * 全是 hidden 字段，客户永远不会去 focus —— 不预热就永远不会绑定。
     * 幂等：只跑一次。
     */
    primeQuoteCaptcha() {
      const form = this.quoteForm();
      if (!form || form.dataset.mzihoPrimed) return;
      form.dataset.mzihoPrimed = '1';
      // 2026-10-22 不刷新提交：验证码脚本绑定时会把 form.submit 存起来、拿到令牌后调用 ——
      //   必须在绑定（下面的 focusin）之前换成 fetch 版，令牌照常带上，页面不跳走。
      form.submit = () => this.sendQuoteInPlace(form);
      const seed = form.querySelector('input[type="hidden"]');
      if (seed) seed.dispatchEvent(new Event('focusin', { bubbles: true }));
    }

    /** 等 Shopify 把验证码绑上（打 data-hcaptcha-bound / data-recaptcha-bound）。 */
    async captchaReady(form, timeoutMs = 8000) {
      const started = Date.now();
      while (Date.now() - started < timeoutMs) {
        if (form.dataset.hcaptchaBound === 'true' || form.dataset.recaptchaBound === 'true') return true;
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      return false;
    }

    async submitQuote() {
      // 已发送状态下吸底按钮（requestSubmit 不看主按钮的 disabled）也不能再发一次
      if (this.quoteSent) return;
      const emailInput = this.querySelector('[data-mziho-quote-email]');
      const nameInput = this.querySelector('[data-mziho-quote-name]');
      const email = (emailInput?.value || '').trim();
      const name = (nameInput?.value || '').trim();

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.showError('Please enter a valid email address so we can send your quote.');
        emailInput?.focus();
        return;
      }
      const qtyInput = this.querySelector('[data-mziho-custom-qty]');
      const qty = Number(qtyInput?.value || 0);
      if (!(qty > 0)) {
        this.showError('Please tell us how many pieces you need.');
        qtyInput?.focus();
        return;
      }
      // 起订量：输入框上的 min 来自配置 customMin。原来只查了 > 0，20 件的询价也发了出去。（2026-09-12）
      const minQty = Number(qtyInput?.min || 0);
      if (minQty && qty < minQty) {
        this.showError(`Our minimum is ${minQty} pieces per design. Please enter ${minQty} or more.`);
        qtyInput?.focus();
        return;
      }

      // 先把图稿传上去换成链接（联系表单本身带不了附件）。传失败不挡询价，邮件里会注明。
      this.setLoading(true);
      const links = await this.uploadArtwork();

      const body = [
        'INSTANT QUOTE REQUEST',
        '',
        `Product: ${this.dataset.productTitle || document.title}`,
        `Page: ${location.origin}${location.pathname}`,
        `Quantity: ${qty}`,
        '',
        ...this.collectSelections(links),
        '',
        'Sent from the MZIHO product configurator.',
      ].join(String.fromCharCode(10));

      // 走 Shopify 原生联系表单（snippets/mziho-product-quote.liquid）。
      // 不能自己拼 FormData 打 /contact —— 店铺开着反垃圾验证，
      // 没有 Liquid 渲染出来的 <form> 就拿不到验证码令牌，必然 400。
      const quoteForm = this.quoteForm();
      if (!quoteForm) {
        this.showError('We could not send your request just now. Please email us directly and we will quote you.');
        this.setLoading(false);
        console.error('[mziho] quote form missing —— snippets/mziho-product-quote.liquid 没渲染出来');
        return;
      }
      const put = (selector, value) => {
        const node = quoteForm.querySelector(selector);
        if (node) node.value = value;
      };
      put('[data-mziho-qf-name]', name);
      put('[data-mziho-qf-email]', email);
      put('[data-mziho-qf-config]', body);
      put('[data-mziho-qf-body]', `Quote request for ${qty} pieces. Full configuration is in the Configuration field.`);

      this.setLoading(true);
      // ⚠ 提交方式取决于验证码有没有绑上，两条路都不能少（2026-09-01 浏览器实测）：
      //   绑上了 → requestSubmit()：触发 submit 事件，让 hCaptcha 求解并填进令牌再提交。
      //   没绑上 → submit()：直接原生提交（店铺以后若关掉反垃圾验证，这条路才走得通）。
      // 反过来用必错：没绑定时 requestSubmit() 会被 preventDefault 后卡死在异步验证码流程里
      // （按钮永远转圈）；绑定了却用 submit() 会跳过求解，服务端回 400 Missing CAPTCHA token。
      this.primeQuoteCaptcha();
      const bound = await this.captchaReady(quoteForm);
      if (bound) quoteForm.requestSubmit();
      // 没绑上验证码：照旧原生整页提交（form.submit 已换成 fetch 版，没有令牌会被挡，所以绕开它）
      else HTMLFormElement.prototype.submit.call(quoteForm);
    }

    /**
     * 2026-10-22 不刷新发送询价（由验证码脚本拿到令牌后调用，见 primeQuoteCaptcha）。
     * POST /contact 跟随跳转后看最终 URL：
     *   contact_posted=true → 成功，原地换成成功卡片；
     *   /challenge          → Shopify 要人工验证：直接打开它给的验证页。验证码脚本提交前已把表单内容按 form_key
     *                         存进 sessionStorage，客户勾完「I am human」由 Shopify 补发并跳回本页，showPostedNotice 提示。
     *                         ⚠ 不能用同一个令牌原生重发 —— 令牌已用过，Shopify 回 400 Invalid CAPTCHA token（10-22 实测）。
     *   其它 / 网络错误      → 报错，按钮恢复，可再点一次。
     */
    async sendQuoteInPlace(form) {
      let response = null;
      try {
        response = await fetch(new URL(form.action, location.href).pathname, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
      } catch (_error) { /* 网络错误，走下面的报错 */ }
      const url = response?.url || '';
      if (response?.ok && url.includes('contact_posted=true')) {
        this.showQuoteSent(form.querySelector('[data-mziho-qf-email]')?.value || '');
        return;
      }
      if (url.includes('/challenge')) {
        location.assign(url);
        return;
      }
      this.setLoading(false);
      this.showError('We could not send your request just now. Please try again, or email us directly and we will quote you.');
    }

    /** 成功卡片：写明发到哪个邮箱 +「Send another request」。表单只是收起，内容都在。 */
    showQuoteSent(email) {
      this.quoteSent = true;
      this.setLoading(false);
      this.update();
      const done = this.querySelector('[data-mziho-quote-done]');
      if (!done) return;
      done.innerHTML = '<strong>✓ Quote request sent</strong>' +
        '<span>We\'ll email your quote' + (email ? ' to <b></b>' : '') + ' within one business day.</span>' +
        '<button type="button" class="mziho-dynamic-quote__again">Send another request</button>';
      const b = done.querySelector('b');
      if (b) b.textContent = email;
      done.querySelector('button').addEventListener('click', () => {
        this.resetQuoteSent();
        this.update();
        this.querySelector('[data-mziho-quote-email]')?.focus();
      });
      done.hidden = false;
      done.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    resetQuoteSent() {
      this.quoteSent = false;
      const done = this.querySelector('[data-mziho-quote-done]');
      if (done) { done.hidden = true; done.textContent = ''; }
    }

    /**
     * 方案 A 兜底：整页提交（要人工验证时）Shopify 跳回本页并带 ?contact_posted=true。
     * 原来靠 Liquid 的 request.url 判断 —— Shopify 没有这个变量，提示从没出现过，改由 JS 看地址栏。
     * 页面已重载、原来的选择没了，所以「Send another request」= 切回 Custom 数量重新填。
     */
    showPostedNotice() {
      if (!/[?&]contact_posted=true/.test(location.search)) return;
      const prices = this.querySelector('.mziho-dynamic-configurator__prices');
      if (!prices) return;
      const note = document.createElement('div');
      note.className = 'mziho-dynamic-quote__done';
      note.setAttribute('role', 'status');
      note.innerHTML = '<strong>✓ Quote request sent</strong><span>Thanks — we reply within one business day.</span>' +
        '<button type="button" class="mziho-dynamic-quote__again">Send another request</button>';
      note.querySelector('button').addEventListener('click', () => {
        note.remove();
        const custom = this.querySelector('[data-custom-quantity]');
        if (custom && !custom.checked) custom.click();
        this.querySelector('[data-mziho-custom-qty]')?.focus();
      });
      prices.before(note);
      // 去掉 ?contact_posted=true，刷新页面不会再弹一次
      const clean = new URL(location.href);
      clean.searchParams.delete('contact_posted');
      clean.hash = '';
      history.replaceState(history.state, '', clean);
      note.scrollIntoView({ block: 'center' });
    }

    setLoading(loading) {
      if (!this.submitButton) return;
      this.submitButton.disabled = loading;
      this.submitButton.setAttribute('aria-busy', String(loading));
      const label = this.querySelector('[data-mziho-submit-label]');
      const spinner = this.querySelector('.mziho-dynamic-configurator__spinner');
      // ⚠ 询价模式下不能恢复成 defaultSubmitLabel（'Add to cart'）——
      // 之前就是这里把「Request a quote」刷回「ADD TO CART」，
      // 看起来像「点了没反应」，其实是点了、跑完了、文案被重置了。
      if (label) label.textContent = loading ? 'Processing…' : (this.isCustomQuantity() ? this.quoteLabel() : this.defaultSubmitLabel);
      if (spinner) spinner.hidden = !loading;
      // mziho-mobile-fix 2026-10-15：手机用户点的是吸底条按钮，原来请求期间它毫无变化，1-2 秒像没点上
      const mobileButton = this.querySelector('[data-mziho-mobile-submit]');
      if (mobileButton) {
        if (!mobileButton.dataset.defaultLabel) mobileButton.dataset.defaultLabel = mobileButton.textContent;
        mobileButton.disabled = loading;
        mobileButton.setAttribute('aria-busy', String(loading));
        mobileButton.textContent = loading ? 'Processing…' : mobileButton.dataset.defaultLabel;
      }
    }

    showError(message) { if (this.errorRegion) { this.errorRegion.textContent = message; this.errorRegion.hidden = false; } }
    clearError() { if (this.errorRegion) { this.errorRegion.textContent = ''; this.errorRegion.hidden = true; } }
  }

  customElements.define('mziho-dynamic-configurator', MzihoDynamicConfigurator);
})();

/* ---- 触屏端加购区折叠 ----
   ≤900px 生效（手机 + 平板）。脚本不跑 = 保持展开，不会把内容藏死。

   ⚠ 视觉按钮用真正的 <button>，不是给 <legend> 套样式。
      iOS Safari 对 legend 的 CSS 支持有缺陷，加 display/padding 会让文字不渲染，
      表现就是「一个没有文字的按钮」。 */
(function () {
  var mq = window.matchMedia('(max-width: 900px)');

  function ensureButton(el) {
    var btn = el.querySelector(':scope > .mzcol-btn');
    if (btn) return btn;
    var lg = el.querySelector(':scope > legend');
    if (!lg) return null;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mzcol-btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.appendChild(document.createTextNode(lg.textContent.trim()));
    var chev = document.createElement('span');
    chev.className = 'mzcol-btn__chev';
    chev.setAttribute('aria-hidden', 'true');
    btn.appendChild(chev);
    lg.insertAdjacentElement('afterend', btn);
    return btn;
  }

  function apply() {
    [].forEach.call(document.querySelectorAll('[data-mziho-collapse]'), function (el) {
      if (mq.matches) {
        var btn = ensureButton(el);
        if (!btn) return;
        el.classList.add('is-collapsible');
        // 已经勾了加购项的默认展开，否则客户看不到自己选了什么
        if (el.querySelector('input[type="checkbox"]:checked')) el.classList.add('is-open');
        btn.setAttribute('aria-expanded', el.classList.contains('is-open') ? 'true' : 'false');
      } else {
        el.classList.remove('is-collapsible', 'is-open');
        var b = el.querySelector(':scope > .mzcol-btn');
        if (b) b.remove();
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mzcol-btn');
    if (!btn) return;
    var box = btn.closest('[data-mziho-collapse]');
    if (!box || !box.classList.contains('is-collapsible')) return;
    var open = box.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);

  document.addEventListener('DOMContentLoaded', apply);
  // 配置器是 JS 渲染的，DOM 可能晚于 DOMContentLoaded 才出现
  setTimeout(apply, 400);
  setTimeout(apply, 1500);
  setTimeout(apply, 3000);
  apply();
})();

/* ===== 缩略图上下箭头（2026-09-04 v3：一次走一张图） =====
   v2 按 clientHeight*0.8 翻页，一按整屏缩略图全换掉，跳跃太大。
   v3 改成「上一张 / 下一张图片」：直接 .click() 相邻缩略图，
   复用既有的切主图 + is-active 逻辑；只在目标不可见时做最小幅度滚动。
   禁用态按图片序号判断，不按滚动位置。 */
(function () {
  var W = 'mziho-thumbnav';
  var THUMB = '.mziho-dynamic-product__thumb';
  var UP = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 15l8-8 8 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var DOWN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9l8 8 8-8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function reduced() {
    try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function tween(el, prop, delta, ms) {
    var start = el[prop];
    var max = prop === 'scrollTop'
      ? el.scrollHeight - el.clientHeight
      : el.scrollWidth - el.clientWidth;
    var target = Math.max(0, Math.min(start + delta, max));
    if (reduced() || ms <= 0 || document.hidden) { el[prop] = target; return; }
    var t0 = null;
    function frame(t) {
      if (t0 === null) { t0 = t; }
      var p = Math.min((t - t0) / ms, 1);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      el[prop] = start + (target - start) * e;
      if (p < 1) { requestAnimationFrame(frame); }
    }
    requestAnimationFrame(frame);
  }
  function mk(cls, label, svg) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = W + '__btn ' + W + '__btn--' + cls;
    b.setAttribute('aria-label', label);
    b.innerHTML = svg;
    return b;
  }
  function build(strip) {
    var p = strip.parentElement;
    if (p && p.classList.contains(W)) { return; }
    var wrap = document.createElement('div');
    wrap.className = W;
    strip.parentNode.insertBefore(wrap, strip);
    var up = mk('up', 'Previous image', UP);
    var down = mk('down', 'Next image', DOWN);
    wrap.appendChild(up);
    wrap.appendChild(strip);
    wrap.appendChild(down);
    function vertical() { return getComputedStyle(strip).flexDirection === 'column'; }
    function thumbs() {
      return Array.prototype.slice.call(strip.querySelectorAll(THUMB));
    }
    function activeIndex(list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].classList.contains('is-active')) { return i; }
      }
      return 0;
    }
    /* 只在目标不可见时滚动，且只滚“刚好露出来”那么多 */
    function reveal(el) {
      var v = vertical();
      var sr = strip.getBoundingClientRect();
      var er = el.getBoundingClientRect();
      var delta = 0;
      if (v) {
        if (er.top < sr.top) { delta = er.top - sr.top - 8; }
        else if (er.bottom > sr.bottom) { delta = er.bottom - sr.bottom + 8; }
      } else {
        if (er.left < sr.left) { delta = er.left - sr.left - 8; }
        else if (er.right > sr.right) { delta = er.right - sr.right + 8; }
      }
      if (delta) { tween(strip, v ? 'scrollTop' : 'scrollLeft', delta, 260); }
    }
    function go(dir) {
      var list = thumbs();
      if (!list.length) { return; }
      var i = activeIndex(list);
      var n = i + dir;
      if (n < 0 || n >= list.length) { return; }
      list[n].click();   // 复用既有监听器：切主图 + 切 is-active
      reveal(list[n]);
      setTimeout(sync, 0); setTimeout(sync, 300);
    }
    up.addEventListener('click', function () { go(-1); });
    down.addEventListener('click', function () { go(1); });
    function sync() {
      var v = vertical();
      var max = v ? (strip.scrollHeight - strip.clientHeight)
                  : (strip.scrollWidth - strip.clientWidth);
      wrap.classList.toggle('is-scrollable', max > 4);
      var list = thumbs();
      var i = activeIndex(list);
      up.disabled = i <= 0;
      down.disabled = i >= list.length - 1;
    }
    /* 用户直接点缩略图时也要刷新禁用态 */
    strip.addEventListener('click', function () { setTimeout(sync, 0); });
    strip.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) { new ResizeObserver(sync).observe(strip); }
    Array.prototype.forEach.call(strip.querySelectorAll('img'), function (im) {
      if (!im.complete) { im.addEventListener('load', sync, { once: true }); }
    });
    setTimeout(sync, 0);
  }
  function run() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.mziho-dynamic-product__thumbs'), build);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
  else { run(); }
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
/* MZIHO-OPTION-VIDEO:START 2026-10-23 选项卡悬停播放视频（购物车 JS 里有同一段，window 标记只挂一次） */
(function () {
  if (window.__mzihoOptionVideo) return;
  window.__mzihoOptionVideo = true;
  var SEL = '.mziho-option__video';
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function videoOf(card) { return card ? card.querySelector(SEL) : null; }
  function play(v) {
    if (!v.getAttribute('src')) v.setAttribute('src', v.dataset.src);
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function stop(v) {
    v.pause();
    v.parentNode.classList.remove('is-playing');
    try { if (v.readyState) v.currentTime = 0; } catch (e) {}
  }

  // 媒体事件不冒泡，用捕获：真正出画面了才把视频盖到图上，没出画面前看到的还是原图
  document.addEventListener('playing', function (e) {
    var v = e.target;
    if (v && v.matches && v.matches(SEL) && !v.paused) v.parentNode.classList.add('is-playing');
  }, true);

  if (canHover) {
    var edge = function (e, fn) {
      var card = e.target.closest ? e.target.closest('label') : null;
      var v = videoOf(card);
      if (v && !(e.relatedTarget && card.contains(e.relatedTarget))) fn(v);
    };
    document.addEventListener('mouseover', function (e) { edge(e, play); });
    document.addEventListener('mouseout', function (e) { edge(e, stop); });
  } else {
    // 触屏没有悬停：点选哪张卡就播哪张，同组其它停下
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio' || !input.checked || !input.closest) return;
      var v = videoOf(input.closest('label'));
      var group = input.closest('fieldset, .mziho-dynamic-options');
      if (group) group.querySelectorAll(SEL).forEach(function (o) { if (o !== v) stop(o); });
      if (v) play(v);
    });
  }
})();
/* MZIHO-OPTION-VIDEO:END */
/* MZIHO-WIZ-MOBILE:BEGIN */
/* ---- MZIHO-WIZ 2026-10-15：描述页签当折叠面板用（所有宽度）----
   WizardPins 的 Details / Artwork / Production 默认全部收起、点同一个标题能再收回。
   我们的页签是纯 CSS radio（描述里的 <script> 不执行），radio 原生不能取消选中，所以在这里补：
   载入时全部取消选中；点已展开的标题 = 收起。 */
(function () {
  function radios() { return [].slice.call(document.querySelectorAll('.mziho-dynamic-product .mz-pd__radio')); }
  function collapseAll() { radios().forEach(function (r) { r.checked = false; }); }
  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.mziho-dynamic-product .mz-pd__tabs label');
    if (!label) return;
    var radio = document.getElementById(label.htmlFor);
    if (radio && radio.checked) { e.preventDefault(); radio.checked = false; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collapseAll);
  else collapseAll();
})();

/* ---- MZIHO-WIZ 2026-10-15：询价模式补「工艺 / 款式」单选 ----
   奖牌（今天改）和挑战币（09-14 起）的 Style 是 cart-only 的变体维度，商品页 Liquid 直接跳过不渲染，
   询价模式里客户选不了、询价邮件里也没有 —— 而 3D Cast 比 Die Struck 贵 43%，报价必须知道。
   这里按 schema 找出 cart-only 的 variant_option，在数量后面插一组单选，包在 [data-mziho-quote-only] 里：
   配置器切询价模式时会统一显隐/启停它（平时禁用，不参与加购、不进校验）；
   collectSelections 按可见的 [data-mziho-field-wrap] 收集，于是邮件里会有「Style: …」。
   name 故意不用 properties[...]，万一被表单带上也不会写进订单属性。
   2026-10-22 店主：询价里的款式第一项加「Not sure – help me choose」并默认选中 —— 不懂工艺的客户不用硬选，
   店主看了图稿再推荐；原来默认勾当前变体（软珐琅），客户没碰邮件里也写着 Soft Enamel，会被当成客户的选择。
   钥匙扣的 Style 是 cart-only 图卡（Liquid 已渲染在询价区），同样在最前面补一张 Not sure 卡并选中，
   图用全站「Recommend for You」那张（option-recommend-for-you.webp）。
   PVC 补丁页不加（店主 10-22）：它的 Style 是补丁 / 行李牌 / 杯垫，客户自己知道要哪种。 */
(function () {
  var NOT_SURE = 'Not sure – help me choose';
  var NOT_SURE_IMG = 'https://cdn.shopify.com/s/files/1/0789/8166/0914/files/option-recommend-for-you.webp';
  var NO_NOT_SURE_CARD = ['/products/custom-pvc-patches'];
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function addNotSureCard(el) {
    if (NO_NOT_SURE_CARD.indexOf(location.pathname.replace(/\/$/, '')) >= 0) return;
    el.querySelectorAll('.mziho-quote-only [data-mziho-field-wrap][data-field-key="Style"].mziho-dynamic-field--image_choice').forEach(function (wrap) {
      var list = wrap.querySelector('.mziho-dynamic-options');
      var first = list && list.querySelector('input[type="radio"]');
      if (!first || list.querySelector('input[value="' + NOT_SURE + '"]')) return;
      var label = document.createElement('label');
      label.className = 'mziho-dynamic-option mziho-dynamic-option--not-sure';
      label.innerHTML = '<input type="radio" name="' + esc(first.name) + '" value="' + esc(NOT_SURE) + '" data-mziho-field data-field-key="Style" data-field-type="image_choice" checked>' +
        '<span><span class="mziho-option__thumb"><img src="' + NOT_SURE_IMG + '?width=600" alt="" width="48" height="48" loading="lazy"></span><span>' + esc(NOT_SURE) + '</span></span>';
      list.insertBefore(label, list.firstChild);
    });
  }
  async function init() {
    var el = document.querySelector('.mziho-dynamic-product mziho-dynamic-configurator');
    if (!el) return;
    addNotSureCard(el);
    var schema = el.schema;
    if (!schema) { try { schema = JSON.parse(el.querySelector('[data-mziho-schema]').textContent); } catch (e) { return; } }
    var fields = (schema && schema.fields || []).filter(function (f) { return f.type === 'variant_option' && f.showIn === 'cart'; });
    if (!fields.length) return;
    var product;
    try { product = await (await fetch(location.pathname.replace(/\/$/, '') + '.js')).json(); } catch (e) { return; }
    var qtyWrap = el.querySelector('[data-mziho-field-wrap].mziho-dynamic-field--quantity');
    var anchor = qtyWrap && (qtyWrap.closest('.mziho-quote-only') || qtyWrap);
    if (!anchor) return;
    fields.slice().reverse().forEach(function (f) {
      var key = f.key;
      if (el.querySelector('[data-mziho-field-wrap][data-field-key="' + key + '"]')) return;
      var idx = product.options.findIndex(function (o) { return (o.name || o) === key; });
      if (idx < 0) return;
      var values = [NOT_SURE].concat(product.options[idx].values || []);
      var picked = NOT_SURE;
      // 2026-10-24 店主：有工艺图的（挑战币 7 页、奖牌 4 页）做成和钥匙扣一样的图片卡，配了视频的卡同样悬停/点选播放
      var cards = !!(f.images && Object.keys(f.images).length);
      var opts = values.map(function (v) {
        var thumb = '';
        if (cards) {
          var img = v === NOT_SURE ? NOT_SURE_IMG + '?width=600' : (f.images[v] || '');
          var vid = v !== NOT_SURE && f.videos && f.videos[v];
          thumb = '<span class="mziho-option__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
            (vid ? '<video class="mziho-option__video" data-src="' + esc(vid) + '" muted loop playsinline preload="none" disablepictureinpicture aria-hidden="true"></video>' +
              '<span class="mziho-option__vbadge" aria-hidden="true"><svg viewBox="0 0 16 16" focusable="false"><path d="M5.8 4.3v7.4L12 8z" fill="currentColor"/></svg></span>' : '') +
            '</span>';
        }
        return '<label class="mziho-dynamic-option' + (cards && v === NOT_SURE ? ' mziho-dynamic-option--not-sure' : '') + '"><input type="radio" name="mziho-quote-' + esc(key) + '" value="' + esc(v) + '"' +
          ' data-mziho-field data-field-key="' + esc(key) + '" data-field-type="' + (cards ? 'image_choice' : 'radio') + '"' + (v === picked ? ' checked' : '') +
          '><span>' + thumb + '<span>' + esc(v) + '</span></span></label>';
      }).join('');
      var box = document.createElement('fieldset');
      box.className = 'mziho-quote-only';
      box.setAttribute('data-mziho-quote-only', '');
      box.disabled = true; box.hidden = true;
      box.innerHTML = '<div class="mziho-dynamic-field mziho-dynamic-field--full mziho-dynamic-field--' + (cards ? 'image_choice' : 'radio') + '" data-mziho-field-wrap data-field-key="' + esc(key) + '">' +
        '<fieldset><legend>' + esc(f.label || ('Select ' + key.toLowerCase())) + '</legend><div class="mziho-dynamic-options' + (cards ? ' mziho-dynamic-options--images' : '') + '">' + opts + '</div></fieldset></div>';
      anchor.insertAdjacentElement('afterend', box);
    });
    // 2026-10-24 店主：挑战币询价模式在款式下面单独加一栏「3D」—— 3D 能和任何款式搭配，所以不并进款式卡。
    // 取值来自 schema 里 Special Effects 的「3D …」卡（图、视频、名称都跟购物车同一份），首项 No 3D 用「不升级」那张图并默认选中。
    // 走到这里的只有 Style 是 cart-only 变体维度的页（挑战币 / 奖牌）；钥匙扣在上面 fields 为空就返回了。
    // 10-24 店主：硬珐琅要整面磨平、做不了 3D → 币页 Special Effects 按款式拆成三组，3D 只在 Soft Enamel / No Color 组里。
    // 这里把各组里的 3D 卡合并去重，并记下哪些款式能配 3D；选了不能配的款式就藏起这一栏、退回 No 3D。
    var fxs = (schema.fields || []).filter(function (f) { return f.type === 'image_choice' && /^Special Effects( \(|$)/.test(f.key); });
    var fx = fxs[0];
    var fx3d = [], seen3d = {}, allow3d = [], anyStyle = false;
    fxs.forEach(function (f) {
      var has = false;
      (f.values || []).forEach(function (v) { if (/^3D\b/.test(v.label)) { has = true; if (!seen3d[v.label]) { seen3d[v.label] = 1; fx3d.push(v); } } });
      if (has) { if (f.showIf && f.showIf.field === 'Style' && f.showIf.equals) allow3d.push(f.showIf.equals); else anyStyle = true; }
    });
    var styleBox = el.querySelector('[data-mziho-quote-only] [data-mziho-field-wrap][data-field-key="Style"]');
    if (fx3d.length && styleBox && !el.querySelector('[data-mziho-field-wrap][data-field-key="3D"]')) {
      var none = (fx.values || [])[0] || {};
      var items = [{ label: 'No 3D', image: none.image }].concat(fx3d);
      var opts3d = items.map(function (v, i) {
        return '<label class="mziho-dynamic-option"><input type="radio" name="mziho-quote-3D" value="' + esc(v.label) + '"' +
          ' data-mziho-field data-field-key="3D" data-field-type="image_choice"' + (i === 0 ? ' checked' : '') + '><span>' +
          '<span class="mziho-option__thumb">' + (v.image ? '<img src="' + esc(v.image) + '" alt="" width="48" height="48" loading="lazy">' : '') +
          (v.video ? '<video class="mziho-option__video" data-src="' + esc(v.video) + '" muted loop playsinline preload="none" disablepictureinpicture aria-hidden="true"></video>' +
            '<span class="mziho-option__vbadge" aria-hidden="true"><svg viewBox="0 0 16 16" focusable="false"><path d="M5.8 4.3v7.4L12 8z" fill="currentColor"/></svg></span>' : '') +
          '</span><span>' + esc(v.label) + '</span></span></label>';
      }).join('');
      var box3d = document.createElement('fieldset');
      box3d.className = 'mziho-quote-only';
      box3d.setAttribute('data-mziho-quote-only', '');
      box3d.disabled = true; box3d.hidden = true;
      box3d.innerHTML = '<div class="mziho-dynamic-field mziho-dynamic-field--full mziho-dynamic-field--image_choice" data-mziho-field-wrap data-field-key="3D">' +
        '<fieldset><legend>Add 3D sculpted relief?</legend><div class="mziho-dynamic-options mziho-dynamic-options--images">' + opts3d + '</div></fieldset></div>';
      styleBox.closest('[data-mziho-quote-only]').insertAdjacentElement('afterend', box3d);
      // 款式联动：Not sure 和能配 3D 的款式显示；其它（硬珐琅）藏起来并选回 No 3D。藏的是里层字段，外层 fieldset 的显隐仍归询价模式管。
      // collectSelections 按 offsetParent 跳过看不见的字段，藏起来时邮件里不会出现「3D: …」。
      var wrap3d = box3d.querySelector('[data-mziho-field-wrap]');
      var sync3d = function () {
        var picked = styleBox.querySelector('input:checked');
        var v = picked ? picked.value : NOT_SURE;
        var ok = anyStyle || v === NOT_SURE || allow3d.indexOf(v) >= 0;
        wrap3d.style.display = ok ? '' : 'none';
        if (!ok) { var n0 = wrap3d.querySelector('input[value="No 3D"]'); if (n0 && !n0.checked) n0.checked = true; }
      };
      styleBox.addEventListener('change', sync3d);
      sync3d();
    }
    // 页面加载时已经是 Custom（比如浏览器回退恢复了选择）→ 立刻按当前模式显隐
    if (typeof el.isCustomQuantity === 'function' && el.isCustomQuantity()) {
      el.querySelectorAll('[data-mziho-quote-only]').forEach(function (b) { b.hidden = false; b.disabled = false; });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- MZIHO-WIZ 2026-10-15：询价模式精简后，备注框给个提示 ----
   电镀/背扣/包装等卡片在询价模式里藏掉了（见 CSS），有要求的客户在备注里写。只填空 placeholder，不覆盖配置里写好的。 */
(function () {
  function init() {
    document.querySelectorAll('.mziho-dynamic-product .mziho-quote-only textarea').forEach(function (t) {
      if (!t.placeholder) t.placeholder = 'Finish, backing, packaging or any other details (optional)';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- MZIHO-WIZ 2026-10-15：吸底按钮文案跟随卡片里的主按钮 ----
   选 Custom 数量时主按钮变「Request a quote」，吸底按钮原来一直写「Add to cart」（点了其实走询价）→ 文案误导。
   只观察主按钮的文字节点、只改吸底按钮（不同节点），不会自触发循环。 */
(function () {
  function init() {
    var label = document.querySelector('.mziho-dynamic-product [data-mziho-submit-label]');
    var mobile = document.querySelector('.mziho-dynamic-product [data-mziho-mobile-submit]');
    if (!label || !mobile) return;
    function sync() {
      var text = label.textContent.trim();
      if (text && mobile.textContent !== text) mobile.textContent = text;
    }
    new MutationObserver(sync).observe(label, { childList: true, characterData: true, subtree: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- MZIHO-WIZ 2026-10-15：手机吸底加购条只在卡片底板（小计+按钮）不在屏幕上时出现 ----
   店主选的方案：卡片按钮看得见 → 藏起来（和 WizardPins 一致）；看不见 → 滑出来。只管 ≤749px，电脑端 CSS 本来就不显示。 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function init() {
    var purchase = document.querySelector('.mziho-dynamic-product .mziho-dynamic-configurator__purchase');
    var bar = document.querySelector('.mziho-dynamic-product .mziho-dynamic-configurator__mobile-bar');
    if (!purchase || !bar || !('IntersectionObserver' in window)) {
      if (bar) bar.classList.add('is-visible');   // 老浏览器：退回常显，不能让加购入口消失
      return;
    }
    // 判据：底板至少 35% 在屏幕里 = 看得见按钮。IntersectionObserver 为主，scroll/resize 直接量位置兜底
    // （有的环境里 IO 回调不触发，按钮不能因此永远藏着或永远露着）。
    function inView() {
      var r = purchase.getBoundingClientRect();
      var visible = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
      return r.height > 0 && visible >= r.height * 0.35;
    }
    function sync() {
      var visible = inView();
      var show = mq.matches && !visible;
      // 底板在屏幕上 → 藏聊天气泡（CSS 只在 ≤749 用这个 class）
      document.body.classList.toggle('mziho-purchase-visible', mq.matches && visible);
      if (bar.classList.contains('is-visible') === show) return;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('mziho-bar-visible', show);
    }
    new IntersectionObserver(sync, { threshold: [0, 0.35, 1] }).observe(purchase);
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (mq.addEventListener) mq.addEventListener('change', sync);
    bar.setAttribute('aria-hidden', 'true');
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* MZIHO-WIZ-MOBILE:END */
/* MZIHO-GALLERY-VIDEO:BEGIN */
/* 配置器商品页图区播放商品视频（2026-10-24）
   模板原来对每个媒体都只输出 preview_image，视频点进去只是一张静态封面（电脑/iPad/手机都一样）。
   section 给视频缩略图加了 data-mziho-media-video / -id / data-mziho-product-handle；这里在主图框里叠一个
   静音循环的 <video>，像动图一样播。点回图片缩略图就暂停隐藏；主图滑出屏幕时也暂停。
   原有 changeMedia 照常把 <img> 换成封面图，视频没加载出来前看到的就是封面。
   Liquid 的 media.sources 只有 1080p mp4 + HLS，720p 只在 /products/<handle>.js 里有 →
   先拉 .js 挑最接近 720 的 mp4，拉不到（2 秒）就用 Liquid 给的 1080p。 */
(function () {
  var THUMB = '.mziho-dynamic-product__thumb';
  var sources = {};
  function loadSources(handle) {
    if (sources[handle]) { return sources[handle]; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    sources[handle] = fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var map = {};
        (p.media || []).forEach(function (m) {
          if (m.media_type !== 'video') { return; }
          var best = null;
          (m.sources || []).forEach(function (s) {
            if (s.format !== 'mp4') { return; }
            if (!best || Math.abs(s.height - 720) < Math.abs(best.height - 720)) { best = s; }
          });
          if (best) { map[m.id] = best.url; }
        });
        return map;
      })
      .catch(function () { return {}; });
    return sources[handle];
  }
  function play(v) {
    if (!v.getAttribute('src')) { return; }
    var p = v.play();
    // iOS 低电量模式等会拒绝自动播放：退回到带控件，让客人自己点（换源打断的 AbortError 不算）
    if (p && p.catch) { p.catch(function (e) { if (e && e.name === 'NotAllowedError') { v.controls = true; } }); }
  }
  function videoIn(box) {
    var v = box.querySelector('video.mziho-main-video');
    if (v) { return v; }
    v = document.createElement('video');
    v.className = 'mziho-main-video';
    v.muted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('preload', 'auto');
    box.appendChild(v);
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!box.classList.contains('is-video')) { return; }
          if (e.isIntersecting) { play(v); } else { v.pause(); }
        });
      }, { threshold: 0.25 }).observe(box);
    }
    return v;
  }
  // 挂在 document 上：在按钮自己的 changeMedia 之后跑；上下箭头 .click() 缩略图也会走到这里
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest(THUMB);
    if (!btn) { return; }
    var root = btn.closest('.mziho-dynamic-product');
    var box = root && root.querySelector('.mziho-dynamic-product__main-media');
    if (!box) { return; }
    var fallback = btn.getAttribute('data-mziho-media-video');
    var v = box.querySelector('video.mziho-main-video');
    var token = box.mzihoVideoToken = {};
    if (!fallback) {
      if (v) { v.pause(); }
      box.classList.remove('is-video');
      return;
    }
    v = videoIn(box);
    v.poster = btn.getAttribute('data-mziho-media-src') || '';
    box.classList.add('is-video');
    var id = btn.getAttribute('data-mziho-media-id');
    var handle = btn.getAttribute('data-mziho-product-handle');
    var wait = new Promise(function (r) { setTimeout(function () { r({}); }, 2000); });
    Promise.race([handle ? loadSources(handle) : Promise.resolve({}), wait]).then(function (map) {
      if (box.mzihoVideoToken !== token) { return; }   // 期间又点了别的缩略图
      var url = map[id] || fallback;
      if (v.getAttribute('src') !== url) { v.src = url; }
      play(v);
    });
  });
  // 有视频缩略图就提前拉好 .js，点的时候不用等
  function prefetch() {
    var b = document.querySelector('[data-mziho-product-handle]');
    if (b) { loadSources(b.getAttribute('data-mziho-product-handle')); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', prefetch); } else { prefetch(); }
})();
/* MZIHO-GALLERY-VIDEO:END */
/* MZIHO-RECENT-VIEWED:BEGIN */
/* 配置器商品页记入「最近浏览」（2026-10-24）
   主题只在原生商品页的 product-info.js 里写 localStorage._halo_recently_viewed，
   配置器模板没有 product-info → 客人逛多少个定制商品都不记，「Recently viewed」最多冒出一两个旧的。
   这里照抄主题的写法：当前商品放最前、去重、最多留 25 个。 */
(function () {
  try {
    var el = document.querySelector('mziho-dynamic-configurator[data-product-id]');
    var id = el && parseInt(el.getAttribute('data-product-id'), 10);
    if (!id) { return; }
    var name = '_halo_recently_viewed';
    var list = JSON.parse(localStorage.getItem(name) || '[]').filter(function (x) { return x !== id; });
    list.unshift(id);
    localStorage.setItem(name, JSON.stringify(list.slice(0, 25)));
  } catch (e) {}
})();
/* MZIHO-RECENT-VIEWED:END */
